import React, { useState } from 'react';

import BharatIconUSA from '../assets/Bharat Icon USA.png';
import BharatIconUSA0 from '../assets/Bharat Icon USA0.mp4';
import BharatIconUSA1 from '../assets/Bharat Icon USA1.jpg';
import BharatIconUSA2 from '../assets/Bharat Icon USA2.jpg';
import BharatIconUSA3 from '../assets/Bharat Icon USA3.jpg';
import BharatIconUSA4 from '../assets/Bharat Icon USA4.jpg';

export default function BharatIconHero() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [
        BharatIconUSA0,
        BharatIconUSA1,
        BharatIconUSA2,
        BharatIconUSA3,
        BharatIconUSA4,
    ];

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    return (
        <section className="flex flex-col md:flex-row w-full max-w-[1400px] mx-auto min-h-[600px] bg-[#121742] font-sans shadow-2xl relative">

            {/* LEFT CONTENT (Text & Button) */}
            <div className="w-full md:w-1/2 p-10 md:p-16 lg:p-24 flex flex-col justify-center text-white relative z-10">
                <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-gray-300 mb-4">
                    Bharat Icon USA
                </p>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 tracking-wide">
                    Confidence.<br />Culture. Purpose.
                </h1>
                <p className="text-lg text-gray-300 italic font-light mb-12">
                    A purpose-driven beauty pageant platform
                </p>

                {/* Feature Lists */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10 mb-14">

                    {/* Focused On Column */}
                    <div>
                        <h3 className="text-[10px] font-bold tracking-[0.2em] uppercase text-gray-400 mb-5">
                            Focused On
                        </h3>
                        <ul className="space-y-4">
                            {["Confidence building", "Leadership development", "Personal branding"].map((item, idx) => (
                                <li key={idx} className="flex items-center gap-3">
                                    {/* FIX: Solid white circle with dark icon for better contrast */}
                                    <div className="w-5 h-5 rounded-full bg-white flex items-center justify-center shrink-0">
                                        <svg className="w-3 h-3 text-[#0b1221]" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="text-sm font-normal text-white">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Opportunities Column */}
                    <div>
                        <h3 className="text-[10px] font-bold tracking-[0.2em] uppercase text-gray-400 mb-5">
                            Opportunities
                        </h3>
                        <ul className="space-y-4">
                            {["Fashion shows", "Modeling & media exposure", "Career growth via WamGlammz"].map((item, idx) => (
                                <li key={idx} className="flex items-start gap-3">
                                    {/* FIX: Solid white circle with dark icon for better contrast */}
                                    <div className="w-5 h-5 rounded-full bg-white flex items-center justify-center shrink-0 mt-0.5">
                                        <svg className="w-3 h-3 text-[#0b1221]" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                    </div>
                                    <span className="text-sm font-normal text-white leading-tight pr-4">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Visit Site Button */}
                <button   onClick={() => window.open("https://bharaticonusa.com/", "_blank")} className="bg-[#966b43] hover:bg-[#855e3a] transition-colors text-white text-xs font-semibold tracking-wider py-3.5 px-8 rounded-full w-fit flex items-center gap-2">
                    VISIT SITE
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                </button>
            </div>

            {/* RIGHT CONTENT (Image Carousel) */}
            <div className="w-full md:w-1/2 min-h-[400px] relative flex-shrink-0 bg-[#0b1221]">

                {typeof images[currentIndex] === 'string' && images[currentIndex].endsWith('.mp4') ? (
                    <video
                        src={images[currentIndex]}
                        className="w-full h-full object-cover object-top absolute inset-0 transition-opacity duration-500 ease-in-out"
                        autoPlay loop muted playsInline
                    />
                ) : (
                    <img
                        src={images[currentIndex]}
                        alt={`Carousel Slide ${currentIndex + 1}`}
                        // FIX: Added object-top to anchor the image to the top, preventing heads from being cropped
                        className="w-full h-full object-cover object-top absolute inset-0 transition-opacity duration-500 ease-in-out"
                    />
                )}

                {/* Top Left Corner Logo Overlap */}
                <div className="absolute top-8 left-8 z-20 w-[162px] h-[127px] overflow-hidden">
                    <img
                        src={BharatIconUSA}
                        alt="Bharat Icon Corner Logo"
                        className="w-full h-full object-cover"
                    />
                </div>
                {/* Left Navigation Button */}
                <button
                    onClick={prevSlide}
                    className="absolute top-1/2 -translate-y-1/2 left-0 -translate-x-1/2 z-20 w-12 h-12 rounded-full bg-white/90 hover:bg-white flex items-center justify-center text-gray-800 shadow-md transition-colors"
                    aria-label="Previous image"
                >
                    <svg className="w-5 h-5 pr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                {/* Right Navigation Button */}
                <button
                    onClick={nextSlide}
                    className="absolute top-1/2 -translate-y-1/2 right-0 translate-x-1/2 z-20 w-12 h-12 rounded-full bg-white/90 hover:bg-white flex items-center justify-center text-gray-800 shadow-md transition-colors"
                    aria-label="Next image"
                >
                    <svg className="w-5 h-5 pl-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </button>

            </div>
        </section>
    );
}   